import { atom } from 'jotai';

export const upgradeIpRestrictionsAtom = atom({
  isModalActive: false,
});
